import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Image = ({ alt, src }) => (
  <LazyLoadImage
    alt={alt}
    className="rounded-xl"
    effect="blur"
    wrapperProps={{
      style: { transitionDelay: "0.3s" },
    }}
    src={src}
  />
);

export default Image;
